import RouteWrapper from "./RouteWrapper";
import RouteInformation from "./RouteInformation";

export default [
  {
    path: "/routes/:id",
    component: RouteWrapper,
    children: [
      {
        path: "",
        name: "route_info",
        component: RouteInformation,
        meta: {
          toolbar: "route",
          tabAccess: "DATABASE",
        },
      },
    ],
  },
];
